const BASE_URL = "https://gameadmin.learntu.org/api";

const API = {
  SIGNUP: `${BASE_URL}/signup`,
  LOGIN: `${BASE_URL}/signin`,
  GET_VIDEOS: `${BASE_URL}/getVideos`,
  SUBMIT_OPTION: `${BASE_URL}/answerQestion`,
  GET_LEVELS_AND_DATA: `${BASE_URL}/seenVideo?user_id=`,
  GET_RESULT: `${BASE_URL}/getResult?user_id=`,
};

export default API;
